import type { MarketTask } from "../domain/market";

/** Display only. The server still authorizes every trade and reward claim. */
export function marketTaskStatus(task: MarketTask, now: number): MarketTask["status"] {
  if (task.status !== "ACTIVE" && task.status !== "COMPLETE") return task.status;
  const deadline = Date.parse(task.status === "COMPLETE" ? task.claimUntil : task.expiresAt);
  return !Number.isFinite(deadline) || deadline <= now ? "EXPIRED" : task.status;
}

/** Actionable quests come before the archive without changing server ordering within groups. */
export function orderedMarketTasks(tasks: readonly MarketTask[], now: number): MarketTask[] {
  const priority = (task: MarketTask) => {
    const status = marketTaskStatus(task, now);
    return status === "COMPLETE" ? 0 : status === "ACTIVE" ? 1 : 2;
  };
  return [...tasks].sort((a, b) => priority(a) - priority(b));
}
